
import imageNotFound from '@com/assets/default_small.png';

export default {
  name: 'appicon',

  componentName: 'appicon',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      imageNotFound: imageNotFound
    };
  },

  computed: {},

  mounted: function mounted() {}
};